module.exports = __webpack_public_path__ + "img/noite-de-fado.d63b2949.jpg";